import { LiquidationOtherProductsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  GET_LIQUIDATION_OTHER_PRODUCTS,
  GET_OTHER_NOTES,
  GET_OTHER_PRODUCTS,
  CLEAR_LIQUIDATION_OTHER_PRODUCTS,
  SEARCH_INPUTS_LIQUIDATION_OTHER_PRODUCTS,
  SELECT_INPUTS_LIQUIDATION_OTHER_PRODUCTS,
  ADD_LIQUIDATION_OTHER_PRODUCT,
  EDIT_LIQUIDATION_OTHER_PRODUCT,
  DELETE_LIQUIDATION_OTHER_PRODUCT,
  CLEAR_SETTLED_NOTES,
  RESTORE_INITIAL_LIQUIDATION_OTHER_PRODUCTS,
} = LiquidationOtherProductsTypes;

const INITIAL_STATE = {
  liquidations: [],
  otherNotes: [],
  otherProducts: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
  payments: [],
};

export const liquidationOtherProductsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SEARCH_INPUTS_LIQUIDATION_OTHER_PRODUCTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case SELECT_INPUTS_LIQUIDATION_OTHER_PRODUCTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case GET_LIQUIDATION_OTHER_PRODUCTS:
      return {
        ...state,
        liquidations: payload.liquidations,
        station: payload.station,
        startDate: payload.startDate,
        endDate: payload.endDate,
      };
    case GET_OTHER_NOTES:
      return {
        ...state,
        otherNotes: payload,
      };
    case GET_OTHER_PRODUCTS:
      return {
        ...state,
        otherProducts: [...payload]
          .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
          .map((item) => ({ ...item, label: item.name || "", value: item.id })),
      };
    case ADD_LIQUIDATION_OTHER_PRODUCT:
      return {
        ...state,
        liquidations: [...state.liquidations, payload],
      };
    case EDIT_LIQUIDATION_OTHER_PRODUCT:
      return {
        ...state,
        liquidations: state.liquidations.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };
    case DELETE_LIQUIDATION_OTHER_PRODUCT:
      return {
        ...state,
        liquidations: state.liquidations.filter((item) => item.id !== payload),
      };
    case CLEAR_SETTLED_NOTES:
      return {
        ...state,
        otherNotes: state.otherNotes.filter((note) => !payload.includes(note.id)),
      };
    case CLEAR_LIQUIDATION_OTHER_PRODUCTS:
    case RESTORE_INITIAL_LIQUIDATION_OTHER_PRODUCTS:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
